import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  // Initialize with 23h 42m 49s as requested
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 42,
    seconds: 49
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center gap-2 text-3xl md:text-4xl font-heading font-bold text-danger ${className}`} data-id="element-56">
      <div className="bg-surface border border-border rounded-lg px-4 py-2 min-w-[80px] text-center" data-id="element-57">
        {formatNumber(timeLeft.hours)}
        <span className="block text-xs text-muted font-body font-normal mt-1" data-id="element-58">
          hs
        </span>
      </div>
      <span className="text-border pb-6" data-id="element-59">:</span>
      <div className="bg-surface border border-border rounded-lg px-4 py-2 min-w-[80px] text-center" data-id="element-60">
        {formatNumber(timeLeft.minutes)}
        <span className="block text-xs text-muted font-body font-normal mt-1" data-id="element-61">
          min
        </span>
      </div>
      <span className="text-border pb-6" data-id="element-62">:</span>
      <div className="bg-surface border border-border rounded-lg px-4 py-2 min-w-[80px] text-center" data-id="element-63">
        {formatNumber(timeLeft.seconds)}
        <span className="block text-xs text-muted font-body font-normal mt-1" data-id="element-64">
          seg
        </span>
      </div>
    </div>;
}